<template>
  <el-card
    class="box-card"
    shadow="hover"
    :body-style="{padding: '30px'}"
  >
    <!-- <el-button type="primary">111</el-button> -->
    <custmonIcon
      class="iconClass"
      :iconName="icon"
    ></custmonIcon>
    <div class="title">{{ title }}</div>
    <div class="content">{{ content }}</div>
    <!-- <el-icon></el-icon> -->
  </el-card>
</template>

<script>
// import CustmonIcon from './custmonIcon.vue'
export default {
  props: {
    icon: "",
    title: "",
    content: "",
  },
  setup(prop, ctx) {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.iconClass {
  font-size: 64px;
}
.title {
  font-size: 18px;
  font-weight: 800;
  line-height: 3em;
}
.content{
  font-size: 14px;
  text-align: left;
}
</style>
